module.exports = __webpack_public_path__ + "static/media/option-1.3233d22e.ogg";